export const TASK_LINK_COLOR_NAME = 'Teal';

export const TASK_LINK_LABEL = 'Task';
